"use client";

// Dotted earth as a backdrop behind the "Pourquoi Kessem" section —
// transparent canvas, only continents as dark dots + faint graticule.
//
// Mounts immediately. Below-the-fold, so the IntersectionObserver
// inside RotatingEarth defers the d3 timer until the user scrolls
// near it — no idle CPU burn during page load.
//
// Position: sticky-inside-absolute. The outer div is offset 480px
// from the top of the section (to leave room for the chrome sphere
// that spills down from Studio). The inner sticky div takes 100vh
// and centers the globe so it stays pinned as the user scrolls
// through Pourquoi.

import RotatingEarth from "@/components/ui/wireframe-dotted-globe";
import { usePerfLevel } from "@/components/site/scene/use-perf-level";

export function PourquoiGlobeBg() {
  const { level, no3D } = usePerfLevel();

  // Skip the rotating globe on phones and low-tier devices — the d3
  // timer + per-frame point projection is enough to keep an underpowered
  // CPU saturated for the whole time the section is on screen.
  if (level === null) return null;
  if (no3D) return null;
  if (level === "mobile-static" || level === "low") return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 bottom-0 top-[480px] z-0"
    >
      <div className="sticky top-0 flex h-screen items-center justify-center">
        <RotatingEarth width={800} height={600} landOnly />
      </div>
    </div>
  );
}
